/* unplugin-vue-components disabled */import { render } from "./exam-Grammar.vue?vue&type=template&id=1f1f2930&scoped=true"
import script from "./exam-Grammar.vue?vue&type=script&lang=js"
export * from "./exam-Grammar.vue?vue&type=script&lang=js"

import "./exam-Grammar.vue?vue&type=style&index=0&id=1f1f2930&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1f2930"]])

export default __exports__